import React, { useState } from "react";
import axios from "axios";
import util from "../../utils/miniUtils";
import { apiErrorMessage } from "./apiError";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { CircularProgress, TextField } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function RecoverPassword( props ) {

    const [email, setEmail] = useState( "" );
    const [loading, setLoading] = useState( false );
    const [finish, setFinish] = useState( false );

    async function recoverPassword() {
        try {
            if ( email.trim() === "" ){
                util.toast().warn( "Escribe tu correo" );
                return;
            }
            setLoading( true );
            const request = await axios.post( `${BASE_URL}/auth/password/forgot`, { email: email.trim() } );
            const { error, msg } = request.data;
            if ( error ) throw msg;
            setLoading( false );
            setFinish( true );
            setEmail( "" );
        }catch ( e ) {
            setLoading( false );
            util.handleError( apiErrorMessage( e ) );
        }
    }

    function handleClose() {
        setFinish( false );
        props.handleClose();
    }

    return(
        <Dialog
            open={props.show}
            onClose={handleClose}
            aria-labelledby="recover-password-title"
            aria-describedby="recover-password-description"
        >
            <DialogTitle id="recover-password-title">Recuperar contraseña</DialogTitle>
            {loading ? (
                <DialogContent className="text-center">
                    <CircularProgress />
                </DialogContent>
            ):(
                finish ? (
                    <div>
                        <DialogContent>
                            <DialogContentText id="recover-password-description">
                                Si el correo está registrado, te enviamos un link para definir tu contraseña.
                                Revisa tu bandeja de entrada y la carpeta de spam.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cerrar</Button>
                        </DialogActions>
                    </div>
                ):(
                    <div>
                        <DialogContent>
                            <DialogContentText id="recover-password-description">
                                Escribe el correo con el que entras al panel y te enviaremos un link para definir una nueva contraseña.
                            </DialogContentText>
                            <TextField
                                id="inputEmailPasswordRecover"
                                type="email"
                                placeholder="tu@email.com"
                                fullWidth
                                margin="normal"
                                name="email"
                                value={email}
                                onChange={( e ) => setEmail( e.target.value )}
                                onKeyDown={( e ) => e.key === "Enter" && recoverPassword()}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button id="cancelButton" onClick={handleClose}>
                                Cancelar
                            </Button>
                            <button id="resetButton" onClick={recoverPassword} className="btn btn-md btn-primary">
                                Enviar link
                            </button>
                        </DialogActions>
                    </div>
                )
            )}
        </Dialog>
    );
}
